import { render, staticRenderFns } from "./preControllersConfig.vue?vue&type=template&id=1f264de8"
import script from "./preControllersConfig.vue?vue&type=script&lang=js"
export * from "./preControllersConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports